import {
  getAuthenticationUrl,
  getAuthenticationToken,
  TAuthProvider,
  PROVIDERS as AUTH_PROVIDERS
} from "./auth";
import {
  createScene,
  deleteScene,
  getSignedUrl,
  initializeUpload,
  completeUpload,
  ingest,
  uploadFile,
  getScenes,
  getScene,
  getScenePreview,
  GetScenesQuery,
  shareScene,
} from "./scenes";
import { getModels } from "./models";
import {
  getInferences,
  GetInferencesQuery,
  validate,
  invalidate,
  updateInference,
  getSceneInferences,
  batchUpdateInferences
} from "./inferences";

export default {
  getAuthenticationUrl,
  getAuthenticationToken,
  getInferences,
  getSceneInferences,
  getScenes,
  getScene,
  getScenePreview,
  shareScene,
  AUTH_PROVIDERS,
  getModels,
  createScene,
  deleteScene,
  getSignedUrl,
  initializeUpload,
  completeUpload,
  ingest,
  uploadFile,
  validateInference: validate,
  invalidateInference: invalidate,
  updateInference,
  batchUpdateInferences
};

export type {
  TAuthProvider,
  GetInferencesQuery,
  GetScenesQuery,
};
